import { render, staticRenderFns } from "./AuctionCountDown.vue?vue&type=template&id=3545588a&scoped=true&"
import script from "./AuctionCountDown.vue?vue&type=script&lang=js&"
export * from "./AuctionCountDown.vue?vue&type=script&lang=js&"
import style0 from "./AuctionCountDown.vue?vue&type=style&index=0&id=3545588a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545588a",
  null
  
)

export default component.exports